/* Purificador (ES) - page scripts (replaces Funnelish core.min.js + the inline snippets) */
(function () {
  'use strict';

  /* 1. Reviews carousel (mobile) - Swiper */
  if (window.Swiper && document.querySelector('.swiper_mobie_new07')) {
    var swiper = new Swiper('.swiper_mobie_new07', {
      loop: true,
      speed: 660,
      slidesPerView: 1.2,
      spaceBetween: -5,
      centeredSlides: true,
      grabCursor: true,
      pagination: {
        el: '.swiper-pagination-mobie-new',
        clickable: true
      }
    });
    swiper.slideNext();
  }

  /* 2. Reviews carousel (desktop) - Owl Carousel */
  if (window.jQuery && jQuery.fn.owlCarousel) {
    jQuery('.owl-carousel').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      navText: ["<i class='fa fa-caret-left'></i>", "<i class='fa fa-caret-right'></i>"],
      autoplay: true,
      autoplayHoverPause: true,
      responsive: {
        0: { items: 1 },
        600: { items: 2 },
        1000: { items: 3 }
      }
    });
  }

  /* 3. FAQ accordion - Funnelish's CSS opens an item when .faq has the class "active" */
  document.addEventListener('click', function (e) {
    var header = e.target.closest ? e.target.closest('.faq .faq-header') : null;
    if (!header) return;
    var item = header.parentNode;
    item.classList.toggle('active');
  });

  /* 4. "VER LA OFERTA ..." buttons: smooth-scroll to the bundles section */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-goto-element]') : null;
    if (!btn) return;
    var target = document.querySelector('[data-goto-target="' + btn.getAttribute('data-goto-element') + '"]');
    if (!target) return;
    e.preventDefault();
    var top = 0, node = target;
    while (node) { top += node.offsetTop; node = node.offsetParent; }
    window.scrollTo({ top: top, behavior: 'smooth' });
  });
})();
